<template>
  <div v-if="estructuraDocumental">
    <AdjuntosOperacionCardList 
      ref="documentCardList"
      :adjuntos="props.documentos" 
      modoEdicion="only-new-files" 
      :configAdjuntos="estructuraDocumental"
      @documents:upload="onDocumentsUpload" />
  </div>
</template>

<script setup lang="ts">
import type { DocumentosModel, EstructuraDocumentalOperacionEnergiaModel, TipoDocumentoOperacionEnergiaEnum } from '@/.shared/.api';
import { toastError } from '@/.shared/services/notification-service';
import { useApi } from '@api/integration';
import AdjuntosOperacionCardList from '@components/operacion/AdjuntosOperacionCardList.vue';
import { onBeforeMount, ref } from 'vue';
import { useIntl } from '@/.shared/services/i18n/i18nservice';
import type { CardFile } from '@/.shared/components/document-card/models/CardFile';
const props = defineProps<{
  documentos: DocumentosModel[]
  idOperacion: string
}>();


const api = useApi();
const estructuraDocumental = ref<EstructuraDocumentalOperacionEnergiaModel[] | null>(null);
const intl = useIntl();
const documentCardList = ref<InstanceType<typeof AdjuntosOperacionCardList>>();
const emit = defineEmits(['documentoSubido']);

onBeforeMount(async () => {
  estructuraDocumental.value = await api.callStandardApi("getEstructuraDocumentalOperacionEnergia", { showLoading: false }, props.idOperacion);
});

const onDocumentsUpload = async () => {
  try {
    await sincronizarCambiosDocumentacion();
    emit('documentoSubido');
  }
  catch(error) {
    toastError(intl.i18n.t('operaciones.guardar_fallo'));
  }
};

const sincronizarCambiosDocumentacion = async () => {
  const files = documentCardList.value?.getFiles();

  if (files === undefined) return;
  
  const filesToSave = files.filter(f => f.status === 'new' || f.status === 'modified');

  await guardarDocumentacion(filesToSave);
}

const guardarDocumentacion = async (files: CardFile[]) => {
  const savePromises = files.map(file =>
  {    
    const typeCode = file.typeCode as TipoDocumentoOperacionEnergiaEnum;
    return api.callStandardApi("postDocumentoOperacionEnergia", { showLoading: true }, props.idOperacion!, typeCode, file.description ?? undefined, file.fileName, file.file!)
  });

  await Promise.all(savePromises);
}
</script>


<style scoped>
.documento i {
  cursor: pointer;
}
</style>